export default "__VITE_ASSET__0a710767__"